// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.email-modal-text {\n  display: block;\n  padding-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
